module.exports = __webpack_public_path__ + "static/media/twunk_32_twunk_icon.50935861.ico";